import { render } from "./ClipModalComponent.vue?vue&type=template&id=c6ce32c8&scoped=true"
import script from "./ClipModalComponent.vue?vue&type=script&lang=js"
export * from "./ClipModalComponent.vue?vue&type=script&lang=js"

import "./ClipModalComponent.vue?vue&type=style&index=0&id=c6ce32c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6ce32c8"]])

export default __exports__